import { render, staticRenderFns } from "./ChargesDiscountsSection.vue?vue&type=template&id=68d22f22"
import script from "./ChargesDiscountsSection.vue?vue&type=script&lang=js"
export * from "./ChargesDiscountsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports